import { useBookIntro } from '@orientaction/hooks_book';
import EbookReaderLayout from './components/EbookReaderLayout';
import IntroContent from './components/IntroContent';
import { useLegacyEbookReader } from './hooks/useLegacyEbookReader';

const RedesignEbookIntro = () => {
  const { initValue, getMyValueBook, setId } = useBookIntro();
  const reader = useLegacyEbookReader({
    getMyValueBook,
    hydrateValue: initValue,
    setId,
  });

  return (
    <EbookReaderLayout {...reader} ebookName="l’Introduction" summaryHref="page-5">
      {(readOnly) => <IntroContent readOnly={readOnly} />}
    </EbookReaderLayout>
  );
};

export default RedesignEbookIntro;
